import React from 'react';
import Button from '../../components/common/Button/Button'
import { useNavigate  } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import ConstructionOutlinedIcon from '@mui/icons-material/ConstructionOutlined';
const ComingSoon = () => {

  const navigate  = useNavigate ();

  const handleButtonClick = () => {
      navigate('/');
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100vh"
      
    >
      <Typography variant="h4" align="center" gutterBottom>
        Pagina in costruzione
      </Typography>
      <ConstructionOutlinedIcon style={{ fontSize: 100 }} fontSize="large" color="White" />
      <Button text="Home" onClick={handleButtonClick}/>
    </Box>
  );
};

export default ComingSoon;